import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-global-line',
    title: 'Web制作',
    subtitle: 'ホームページ制作',
    description: '企業サイト、ランディングページ、コーポレートサイトまで、目的に合わせたWebサイトを制作します。HTML/CSS/JavaScriptを用いた静的サイトから、CMSを活用した更新性の高いサイトまで対応。スマートフォン・タブレット対応（レスポンシブデザイン）は標準装備です。',
    features: ['コーポレートサイト制作', 'ランディングページ制作', 'レスポンシブデザイン', 'SEO初期設定'],
  },
  {
    icon: 'ri-palette-line',
    title: 'デザイン・印刷',
    subtitle: 'グラフィックデザイン全般',
    description: '名刺、チラシ、パンフレット、ポスターなど、紙媒体のデザインから印刷まで一貫して対応。DTPオペレーションにも精通しており、データ入稿・印刷手配までお任せいただけます。',
    features: ['名刺デザイン・印刷', 'チラシ・フライヤー', 'パンフレット・カタログ', 'ロゴ・ブランディング'],
  },
  {
    icon: 'ri-video-line',
    title: '動画制作',
    subtitle: '映像コンテンツ制作',
    description: '企業紹介動画、商品紹介、採用動画、SNS用ショート動画など、目的と予算に合わせた動画を企画・撮影・編集までワンストップで提供します。',
    features: ['企業紹介動画', '商品・サービス紹介', '採用プロモーション', 'SNSショート動画'],
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'BPO・事務サポート',
    subtitle: 'ビジネスプロセスアウトソーシング',
    description: 'データ入力、書類のスキャン・電子化、名簿作成、帳票作成など、日常の事務作業を代行します。就労継続支援の仕組みを活かし、高品質かつリーズナブルなBPOサービスを提供。Web制作やデザインの企画・品質管理はヴェリテが責任を持って行います。',
    features: ['データ入力・集計', '書類スキャン・電子化', '名簿・帳票作成', '軽作業代行全般'],
  },
];

export default function Services() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />

      <section className="pt-24 md:pt-32 pb-16 md:pb-20">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-600 bg-accent-100 px-4 py-1.5 rounded-full mb-6">
                Our Services
              </span>
              <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-6">
                事業内容
              </h1>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl mx-auto">
                販促物やWebコンテンツを通じた企業・店舗の情報発信支援。仙台のパートナーとして、あなたのビジネスを前に進めます。
              </p>
            </div>

            <div className="space-y-10">
              {services.map((svc, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 rounded-2xl border border-background-200 p-6 md:p-8"
                >
                  <div className="flex flex-col md:flex-row gap-6">
                    <div className="flex-shrink-0">
                      <div className="w-14 h-14 rounded-xl bg-accent-100 flex items-center justify-center">
                        <i className={`${svc.icon} text-2xl text-accent-600`} />
                      </div>
                    </div>
                    <div className="flex-1">
                      <span className="text-xs font-semibold tracking-widest uppercase text-accent-600">
                        {svc.subtitle}
                      </span>
                      <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mt-2 mb-3">
                        {svc.title}
                      </h2>
                      <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
                        {svc.description}
                      </p>
                      <div className="flex flex-wrap gap-2 mb-4">
                        {svc.features.map((feat, fidx) => (
                          <span
                            key={fidx}
                            className="inline-block text-xs font-medium text-foreground-700 bg-background-100 border border-background-300 rounded-full px-3 py-1.5"
                          >
                            {feat}
                          </span>
                        ))}
                      </div>
                      <Link
                        to="/pricing"
                        className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer"
                      >
                        料金の目安はこちら
                        <i className="ri-arrow-right-line" />
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-14">
              <p className="text-foreground-600 mb-6">
                ご不明な点がありましたら、お気軽にお問い合わせください。
              </p>
              <Link
                to="/contact"
                className="inline-block px-8 py-4 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                お問い合わせはこちら
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}